export default {
  buttons: {
    auth: {
      className: 'share__button',
      text: 'shareContent.buttons.auth.text',
    },
  },
};
